import { AxiosError, AxiosResponse } from "axios";
import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { CompanySupportTeamAxios } from "../Contracts/Axios/CompanySupportTeamAxios";
import { IBuxtonSupportTeamMember, IServiceResult } from "../Models/Models";
import * as types from "./Types";

export const getCompanySupportTeam: ActionCreator<
  ThunkAction<any, any, any, any>
> = () => {
    return (dispatch: Dispatch<any>) => {
        const companySupportTeamAxios = new CompanySupportTeamAxios();
        const promise = companySupportTeamAxios.GetCompanySupportTeam();

        promise
            .then((response: IServiceResult<Array<IBuxtonSupportTeamMember>>) => {
                dispatch(getCompanySupportTeamSuccess(response));
            })
            .catch((error: any) => {
                dispatch(getCompanySupportTeamFailure(error));
            });
    };
};

const getCompanySupportTeamSuccess = (
    response: IServiceResult<Array<IBuxtonSupportTeamMember>>
) => ({
    type: types.GET_COMPANY_SUPPORT_TEAM_SUCCESS,
    data: response.data,
});

const getCompanySupportTeamFailure = (error: AxiosError) => ({
    type: types.GET_COMPANY_SUPPORT_TEAM_FAILURE,
    data: error,
});
